import React from 'react';
import Button from '@mui/material/Button'

function DeleteIssue() {
  return <div>
          <Button>Delete Issue</Button>
  </div>;
}

export default DeleteIssue;
